import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import DialogWrapper from "components/DialogWrapper";
import Loader from "components/Loader";
import { snack } from "components/toast";
import { useEffect, useState } from "react";
import { DialogProps } from "types";
import CachedIcon from "@mui/icons-material/Cached";

interface Props extends DialogProps {
  onSelectionChange: (selectedValues: string[]) => void;
  onSync: any;
  onTraceSelectionChange: (traceSelectedValues: string[]) => void;
  tanClientCredentials: any;
}

const options = [
  { label: "Profile", value: "P" },
  { label: "e-Challan", value: "EC" },
  { label: "AR (CA)/Forms", value: "F" },
  { label: "e-Proceedings", value: "EP" },
];

const traceOptions = [{ label: "Traces Inbox", value: "CI", disabled: false }, { label: "Traces Outstanding Demand", value: "OD", disabled: false }, { label: "Traces Statements", value: "F", disabled: false }];

function SelectModulePopUp(props: Props) {
  const { open, setOpen, onSelectionChange, onTraceSelectionChange, onSync, tanClientCredentials } =
    props;
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [traceSelectedValues, setTraceSelectedValues] = useState<String[]>([]);
  const [traceSelectAll, setTraceSelectAll] = useState(false);

  useEffect(() => {
    if (selectAll) {
      const selectedArry = options.map((option) => option.value);
      setSelectedValues([...selectedArry]);
      onSelectionChange(selectedArry);
    } else {
      setSelectedValues([]);
    }
    if (traceSelectAll) {
      const selectedArry = traceOptions.filter(option => !option.disabled).map(option => option.value);
      setTraceSelectedValues([...selectedArry]);
      onTraceSelectionChange(selectedArry);
    } else {
      setTraceSelectedValues([]);
    }
  }, [selectAll, traceSelectAll]);

  useEffect(() => {
    setSelectedValues([]);
    setTraceSelectedValues([]);
    setTraceSelectAll(false);
    setSelectAll(false);
  }, [open]);

  const handleCheckboxChange = (value: string) => {
    const currentIndex = selectedValues.indexOf(value);
    const newSelectedValues = [...selectedValues];

    if (currentIndex === -1) {
      newSelectedValues.push(value);
    } else {
      newSelectedValues.splice(currentIndex, 1);
    }

    setSelectedValues(newSelectedValues);
    onSelectionChange(newSelectedValues);
  };

  const handleTraceCheckboxChange = (value: string) => {
    const currentIndex = traceSelectedValues.indexOf(value);
    const newSelectedValues = [...selectedValues];

    if (currentIndex === -1) {
      newSelectedValues.push(value);
    } else {
      newSelectedValues.splice(currentIndex, 1);
    }

    setTraceSelectedValues(newSelectedValues);
    onTraceSelectionChange(newSelectedValues);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (selectedValues.length > 0 || traceSelectedValues.length > 0) {
      onSync();
      // setSelectedValues([])
    } else {
      snack.error("Please select atleast one module");
    }
  };

  const handleCancel = () => {
    setSelectedValues([]);
    setTraceSelectedValues([]);
    setOpen(false);
  };

  return (
    <DialogWrapper title="Select Income Tax TAN Modules" open={open} setOpen={setOpen}>
      <form onSubmit={handleSubmit}>
        <Box mt={2}>
          <FormControlLabel
            control={
              <Switch
                checked={selectAll}
                onChange={() => setSelectAll(!selectAll)}
                color="primary"
                disabled={!tanClientCredentials?.password}
              />
            }
            label="Select All TAN Modules"
          />
          {!tanClientCredentials?.password && (
            <Typography color={"red"} fontSize={"10px"}>
              Add TAN Password to select and Sync TAN modules
            </Typography>
          )}
          <Box mb={2}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={selectedValues.includes(option.value)}
                    onChange={() => handleCheckboxChange(option.value)}
                    disabled={!tanClientCredentials?.password}
                  />
                }
                label={option.label}
              />
            ))}
          </Box>

          <FormControlLabel
            control={
              <Switch
                checked={traceSelectAll}
                onChange={() => setTraceSelectAll(!traceSelectAll)}
                color="primary"
                disabled={!tanClientCredentials?.traceUserId}
              />
            }
            label="Select Traces Modules"
          />
          {!tanClientCredentials?.traceUserId && (
            <Typography color={"red"} fontSize={"10px"}>
              Add Traces Credentials to select and Sync Trace modules
            </Typography>
          )}
          <Box mb={2}>
            {traceOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={traceSelectedValues.includes(option.value)}
                    onChange={() => handleTraceCheckboxChange(option.value)}
                    disabled={!tanClientCredentials?.traceUserId}
                  />
                }
                label={option.label}
              />
            ))}
          </Box>

          <Box>
            <Typography mt={1} fontSize={"10px"}>
              <span style={{ color: "red" }}>Disclaimer: </span>
              It is recommended that you refrain from logging in to the Income Tax portal on a
              second device while automation processes are running in the background. This will help
              to avoid any potential disruptions or errors that may occur due to conflicting
              sessions.
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            <Button
              style={{ width: "100%", marginBottom: "10px" }}
              type="submit"
              size="large"
              color="primary"
              variant="contained"
              startIcon={<CachedIcon />}
            >
              Start SYNC
            </Button>
            <Button
              onClick={handleCancel}
              style={{ width: "100%", marginRight: "10px" }}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </form>
    </DialogWrapper>
  );
}

export default SelectModulePopUp;
